import { Facet, SelectedFacet } from '../../components/facets/interfaces';
import pushToDataLayer, { PushEventType, TrackingEvent } from './pushToDataLayer';

const categoryCodesFilterCode: string = 'categoryCodesWithoutBrand';
export enum FiltersEventType {
  VIEWED = 'viewed_filters',
  SELECTED = 'selected_filters',
  CONVERTED_SELECTED_PURCHASE = 'converted_selected_filters_purchase',
  CONVERTED_SELECTED_ADD_TO_CART = 'converted_selected_filters_add_to_cart'
}

type FacetsFilters = ReadonlyArray<Facet> | ReadonlyArray<SelectedFacet> | undefined;

export function generateFacetData(facets: FacetsFilters): ReadonlyArray<string> {
  const facetsData: Array<string> = [];
  if (facets) {
    const generatedData: Array<string> = facets.flatMap(
      (facet: Facet | SelectedFacet): Array<string> => generateFacetStrings(facet)
    );
    facetsData.push(...generatedData);
  }

  return facetsData;
}

function generateFacetStrings(facet: Facet | SelectedFacet): string[] {
  let result: string[] = [];
  if (facet.type === 'values') {
    const baseCode: string = 'facetCode' in facet ? facet.facetCode : facet.code;
    result = facet.values.slice(0, 10).map((value): string => `${baseCode}:${value.code}`);
  }

  return result;
}

export const trackFiltersActions = (
  filtersEventType: FiltersEventType,
  searchFilters: ReadonlyArray<string>,
  anonymousId: string | null,
  authenticatedId: string | null,
  searchMetadata: Record<string, string | undefined>,
  categoryFilter?: string
): void => {
  const filtersData: Array<string> = [...searchFilters];
  if (categoryFilter) {
    filtersData.push(`${categoryCodesFilterCode}:${categoryFilter}`);
  }

  const ecommerceEvent: PushEventType = {
    type: TrackingEvent.ECOMMERCE,
    event: filtersEventType,
    anonymousId,
    authenticatedId,
    ecommerce: {
      searchMetadata: {
        ...searchMetadata
      },
      filters: filtersData
    }
  };

  pushToDataLayer(ecommerceEvent);
};

export default trackFiltersActions;
